import * as React from "react"
import Autoplay from "embla-carousel-autoplay" 
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel"
import Hero from "./Hero"
import Hero2 from "./Hero2"
import Hero3 from "./Hero3"
import Hero4 from "./Hero4"

export default function CarouselPlugin() {
  const plugin = React.useRef(
    Autoplay({ delay: 2000, stopOnInteraction: true })
  )

  return (
    <div className="w-full h-full">
    <Carousel
      plugins={[plugin.current]}
      className="w-full h-full"
      onMouseEnter={plugin.current.stop}
      onMouseLeave={plugin.current.reset}
    >
      <CarouselContent>
          <CarouselItem>
            <Hero/>
          </CarouselItem>
          <CarouselItem>
            <Hero2/>
          </CarouselItem>
          <CarouselItem>
            <Hero3/>
          </CarouselItem>
          <CarouselItem>
            <Hero4/>
          </CarouselItem>
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
    </Carousel>
    </div>
  )
}
